module.exports = __webpack_public_path__ + "static/media/alpha_22.ac7ff524.png";